<template>
  <Fragment>
    <slot v-if="isSuperUser" />

    <template v-else>
      <div v-loading="isChecking" class="bdx-status-pending-wrapper">
        <template v-if="!isChecking">
          <slot v-if="status" />
          <BaseAlert v-else variant="primary" class="pl-5">
            <BaseIcon
              icon="exclamation-triangle"
              tag="i"
              class="position-absolute"
            />

            Export of BDX files is available after you complete any pending BDX
            Match and/or BDX Status items. Please click the
            <router-link
              to="/manage-bdx"
              class="text-white font-weight-normal text-underline"
              >link</router-link
            >
            to address all open items. If you require additional support, please
            contact
            <a href="mailto:support@limeiq.com" class="text-white"
              >support@limeiq.com</a
            >
          </BaseAlert>
        </template>
      </div>
    </template>
  </Fragment>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from '@vue/composition-api'
import { Fragment } from 'vue-fragment'

import { useCurrentUser, useUserCompany } from '@composables'
import { LincolnNewGlobalUMRService, LincolnBDXService } from '@services'

import { BaseAlert, BaseIcon } from '@components/base'

export default defineComponent({
  name: 'BDXStatusPendingWrapper',
  components: {
    Fragment,

    BaseAlert,
    BaseIcon
  },
  setup() {
    const { isSuperUser } = useCurrentUser()
    const {
      id: companyId,
      roleName: companyRoleName,
      roleValue: companyRoleValue
    } = useUserCompany()

    const newGlobalUMRStatus = ref(false)
    const pendingBDXStatus = ref(false)

    const status = computed(() => {
      if (isChecking.value) return false

      return newGlobalUMRStatus.value && pendingBDXStatus.value
    })

    const isChecking = ref(true)

    const checkNewGlobalUMRStatus = async () => {
      isChecking.value = true

      try {
        const { data } = await LincolnNewGlobalUMRService.check(companyId.value)
        const { data: results } = data || {}

        newGlobalUMRStatus.value = !results.exists
      } catch (e) {
        isChecking.value = false

        console.error(e)
      }
    }

    const checkBDXPendingStatus = async () => {
      isChecking.value = true

      try {
        const { data } = await LincolnBDXService.checkPendingStatus(
          companyRoleName.value,
          companyRoleValue.value
        )
        const { data: results } = data || {}

        pendingBDXStatus.value = !results.exists
      } catch (e) {
        isChecking.value = false

        console.error(e)
      }
    }

    onMounted(async () => {
      isChecking.value = true

      if (isSuperUser.value) {
        isChecking.value = false
      } else {
        if ('TPA' === companyRoleName.value){
          await checkNewGlobalUMRStatus()
          await checkBDXPendingStatus()
        } else {
          pendingBDXStatus.value = true
          newGlobalUMRStatus.value = true
        }

        isChecking.value = false
      }
    })

    return {
      isSuperUser,

      status,

      isChecking
    }
  }
})
</script>

<style scoped>
.bdx-status-pending-wrapper {
  min-height: 60px;
}

.bdx-status-pending-wrapper .alert {
  max-width: 860px;
  margin: 0 auto;
}

.bdx-status-pending-wrapper .alert >>> .base-icon {
  font-size: 18px;
  top: 16px;
  left: 16px;
}
</style>
